import { render, staticRenderFns } from "./LeftNav.vue?vue&type=template&id=6a994498&scoped=true"
import script from "./LeftNav.vue?vue&type=script&lang=js"
export * from "./LeftNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a994498",
  null
  
)

export default component.exports